import { FC, useMemo, useEffect } from 'react'
import InternalLayoutContainer from 'components/features/pfm/InternalLayout/InternalLayoutContainer'
import InternalSidebarContainer from 'components/features/pfm/InternalSidebar/InternalSidebarContainer'
import { NotificationTrayWrapper } from 'components/features/pfm/NotificationTray/NotificationTrayWrapper'
import styles from 'components/features/coaching/advisorPage/AdvisorPage/AdvisorPage.styl'
import { SingleColumnLayout } from 'components/layouts/Layouts'
import { PageHeading } from 'components/atoms/Text'
import { AllSessions } from 'components/features/coaching/advisorPage/AllSessions/AllSessions'
import { memberInfoGuard } from 'guards/globalGuards'
import { connectShadedLoadable } from 'helpers/loadableHelpers'
import { StrippedFragment } from 'components/features/pfm/StrippedFragment/StrippedFragment'
import { PageAnchorHandler } from 'handlers/PageAnchorHandler/PageAnchorHandler'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { InternalPageRedirect } from 'components/features/pfm/InternalPageRedirect/InternalPageRedirect'
import Anchor from 'components/atoms/navigation/Anchor'
import HighlightsContainer from 'components/features/pfm/Highlights/HighlightsContainer'
import { PageContent } from 'components/features/coaching/advisorPage/PageContent/PageContent'
import { meetingsListRequestActionCreator, GetMeetingsInfoAction } from 'components/features/coaching/advisorStore/actions/advisorPageActions'

const guards = [
  memberInfoGuard,
]

export const RendererWithGuards = connectShadedLoadable<
  {}, {}, {}
>(() => () => ({}), () => ({}), guards)(StrippedFragment)


type AdvisorPageProps = {}
export const AdvisorPage: FC<AdvisorPageProps> = (props) => {
  const dispatch = useStoreDispatch()
  useEffect(() => {
    dispatch(new GetMeetingsInfoAction())
  }, [dispatch])

  return (
    <InternalPageRedirect>
      <RendererWithGuards>
        <AdvisorPageInner { ...props } />
      </RendererWithGuards>
    </InternalPageRedirect>
  )
}

const AdvisorPageInner: FC<AdvisorPageProps> = () => {
  const dispatch = useStoreDispatch()
  useEffect(() => {
    dispatch(meetingsListRequestActionCreator.request({}))
  }, [dispatch])

  const notifications = useMemo(() => (
    <NotificationTrayWrapper
      renderLevel='page'
      placement='future_general'
      isPositionRelative
    />
  ), [])

  return (
    <>
      <PageAnchorHandler placement='coaching'>
        <div className={ styles.anchorPlaceholder } />
      </PageAnchorHandler>
      <InternalLayoutContainer
        sidebar={ <InternalSidebarContainer /> }
        notifications={ notifications }
      >
        <div className={ styles.content }>
          <SingleColumnLayout className={ styles.column }>
            <div className={ styles.header }>
              <PageHeading className={ styles.pageTitle }>Your Coaching</PageHeading>
            </div>
            <div className={ styles.moduleRow }>
              <PageContent />
            </div>
            <div className={ styles.allSessions }>
              <AllSessions />
            </div>
          </SingleColumnLayout>
          <section className={ styles.quickLookSection }>
            <Anchor placement='coaching_carousel'>
              <HighlightsContainer placement='coaching_carousel' />
            </Anchor>
          </section>
        </div>
      </InternalLayoutContainer>
    </>
  )
}
